<template>
    <div>
        <el-row style="display: flex;">
            <el-input class="search-el" size="mini" v-model="query.share_nickname" clearable
                placeholder="小裂变推客昵称"></el-input>
            <el-input class="search-el" size="mini" v-model="query.mobile_phone" clearable placeholder="手机号"></el-input>
            <el-button type="primary" size="mini" @click="getList()">查询</el-button>
            <el-button type="primary" size="mini" @click="dialogVisible = true">添加</el-button>
            <el-button type="warning" icon="el-icon-download" size="mini" @click="downloadTemplate()">下载模板</el-button>
            <el-upload action="/backend/xiao/liebian/importShareUser" :headers="uploadActionHeaders" :multiple="false"
                name="file" accept=".xls, .xlsx" :show-file-list="false" :on-success="uploadSuccessFun"
                :on-progress="uploadProgress" :file-list="fileList">
                <el-button size="mini" type="primary" v-loading.fullscreen.lock="fullscreenLoading"
                    style="margin-left: 10px;">导入<i class="el-icon-upload el-icon--right"></i></el-button>
            </el-upload>
        </el-row>

        <el-row>
            <el-table v-loading="loading" :data="list" border size="mini" :stripe="true"
                style="width: 100%; margin: 10px 0">
                <el-table-column prop="id" label="ID" align="center" min-width="5%"></el-table-column>
                <el-table-column prop="share_nickname" label="推客昵称" align="center" min-width="20%"></el-table-column>
                <el-table-column prop="user_id" label="用户ID" align="center" min-width="8%"></el-table-column>
                <el-table-column prop="mobile_phone" label="手机号" align="center" min-width="8%"></el-table-column>
                <el-table-column prop="nickname" label="昵称" align="center" min-width="5%"></el-table-column>
                <el-table-column prop="agent_id" label="分会ID" align="center" min-width="5%"></el-table-column>
                <el-table-column prop="name" label="会名" align="center" min-width="12%"></el-table-column>
                <el-table-column prop="real_name" label="会长名称" align="center" min-width="5%"></el-table-column>
                <el-table-column prop="created_at" label="添加时间" align="center" min-width="12%"></el-table-column>

                <el-table-column label="操作" align="center" min-width="6%">
                    <template slot-scope="{ row }">
                        <el-button type="danger" size="mini" @click="del(row.id)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row>
            <div class="block">
                <el-pagination background @current-change="getList" :current-page.sync="query.page"
                    :page-size="query.limit" layout="total, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </el-row>

        <el-dialog title="设置小裂变推客" :visible.sync="dialogVisible" :close-on-click-modal="false"
            :close-on-press-escape="false" :before-close="addEditFormOnClose" width="50%">
            <el-form label-width="100px" class="demo-ruleForm">
                <el-form-item label="推客昵称">
                    <el-input size="mini" v-model="searchUserInfo.share_nickname" maxlength="48" show-word-limit
                        placeholder="请输入推客昵称"></el-input>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input size="mini" v-model="searchUserInfo.mobile_phone" show-word-limit placeholder="请输入手机号"
                        style="width: 300px;" maxlength="11"></el-input>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <el-button type="primary" size="mini" @click="searchUser()" :disabled="searchUserBtn">
                        查询
                    </el-button>
                </el-form-item>

                <el-form-item label="昵称">
                    {{ searchUserInfo.nickname }}
                </el-form-item>
                <el-form-item label="分会ID">
                    {{ searchUserInfo.agent_id }}
                </el-form-item>
                <el-form-item label="会名">
                    {{ searchUserInfo.name }}
                </el-form-item>
                <el-form-item label="会长名称">
                    {{ searchUserInfo.real_name }}
                </el-form-item>

                <el-form-item>
                    <el-button size="mini" @click="addEditFormOnClose()">取 消</el-button>
                    <el-button size="mini" type="primary" @click="createShareUser()" :loading="updateLoading">确
                        定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import { shareUserList, searchUser, addShareUser, delShareUser } from "@/api/xiao";

export default {
    data: function () {
        return {
            fullscreenLoading: false,
            uploadActionHeaders: {
                'AdminId': Number(window.localStorage.getItem('admin_id'))
            },
            fileList: [],
            searchUserBtn: false,
            updateLoading: false,
            dialogVisible: false,
            list: [],
            loading: false,
            total: 0,
            query: {
                page: 1,
                limit: 20,
                share_nickname: "",
                mobile_phone: "",
            },
            searchUserInfo: {
                share_nickname: "",
                mobile_phone: "",
                nickname: "",
                agent_id: "",
                name: "",
                real_name: ""
            },

            listContentLoading: false,
        };
    },
    created: function () {
        this.getList();
    },
    methods: {
        downloadTemplate () {
            window.open('https://res.defen.hzxinquanzi.com/activity/%E5%B0%8F%E8%A3%82%E5%8F%98%E6%8E%A8%E5%AE%A2.xlsx?v=' + Math.random());
        },
        uploadProgress () {
            this.fullscreenLoading = true;
        },
        uploadSuccessFun (res) {
            if (res.code == 0) {
                this.$message({
                    showClose: true,
                    duration: 6000,
                    message: res.message,
                    type: 'error'
                });
            } else {
                this.getList();
                this.$message({
                    dangerouslyUseHTMLString: true,
                    showClose: true,
                    duration: 0,
                    message: res.message,
                    type: 'success'
                });
            }
            this.fullscreenLoading = false;
            this.fileList = [];
        },
        createShareUser () {
            if (this.searchUserInfo.name == '') {
                this.$message({
                    message: "请先查询手机号用户",
                    type: "error",
                });
                return;
            }
            if (this.searchUserInfo.share_nickname == '' || this.searchUserInfo.mobile_phone == '') {
                this.$message({
                    message: "请按要求填写",
                    type: "error",
                });
                return;
            }
            this.updateLoading = true;
            addShareUser({ share_nickname: this.searchUserInfo.share_nickname, mobile_phone: this.searchUserInfo.mobile_phone }).then((response) => {
                if (response.status == 2000) {
                    this.$message({
                        showClose: true,
                        message: "成功",
                        type: "success",
                    });
                    this.addEditFormOnClose();
                    this.getList();
                }
            });
        },
        searchUser () {
            this.searchUserBtn = true;
            searchUser({ share_nickname: this.searchUserInfo.share_nickname, mobile_phone: this.searchUserInfo.mobile_phone }).then((response) => {
                if (response.status == 2000) {
                    this.searchUserInfo.nickname = response.data.nickname;
                    this.searchUserInfo.agent_id = response.data.agent_id;
                    this.searchUserInfo.name = response.data.name;
                    this.searchUserInfo.real_name = response.data.real_name;
                } else {
                    this.searchUserBtn = false;
                }
            });
        },
        addEditFormOnClose () {
            this.searchUserInfo = {
                share_nickname: "",
                mobile_phone: "",
                nickname: "",
                agent_id: "",
                name: "",
                real_name: ""
            };
            this.searchUserBtn = false;
            this.dialogVisible = false;
            this.updateLoading = false;
        },
        getList () {
            this.loading = true;
            shareUserList(this.query).then((response) => {
                this.list = response.data.list;
                this.total = response.data.total;
                this.loading = false;
            });
        },
        del (id) {
            this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                delShareUser({
                    id: id,
                }).then((response) => {
                    if (response.status == 2000) {
                        this.getList();
                        this.$message({
                            showClose: true,
                            message: "删除成功",
                            type: "success",
                        });
                    }
                });
            });
        },
    }
}
</script>

<style></style>